import remote from "../../../../services/remote";
import {
    getDataSuccess,
    getDataFailure,
    addBookingSuccess,
    addBookingFailure,
    getCaseSuccess,
    getCaseFailure,
    addDentistFailureAction,
    addDentistSuccessAction,
    addPatientFailure,
    addPatientSuccess,
    getParentCasesSuccess,
    getParentCasesFailure,
    setFilterValuesSuccess,
    setFilterValuesFailure,
    getAllPatientsSuccess,
    getAllPatientsFailure,
    getDataSmallCalendarSuccess,
    getSmallCalendarDataFailure,
    addVacationDaysSuccess,
    addVacationDaysFailure,
    getVacationDaysSuccess,
    getVacationDaysFailure, deleteVacationDaySuccess, deleteVacationDayFailure,
} from "./actions";
import {setFilterValuesSuccessDentist} from '../../User/Home/actions';
import {
    GET_DASHBOARD_DATA_REQUEST,
    ADD_BOOKING_REQUEST,
    GET_CASE_DETAILS_REQUEST,
    ADD_DENTIST_REQUEST,
    ADD_PATIENT_DASHBOARD_REQUEST,
    GET_PARENT_CASES_REQUEST,
    UPDATE_TABLE_CONFIG,
    GET_ALL_PATIENTS_REQUEST,
    GET_SMALL_CALENDAR_DATA_REQUEST,
    ADD_VACATION_DAYS_REQUEST,
    GET_VACATION_DAYS_REQUEST, DELETE_VACATION_DAYS_REQUEST,
} from "./constants";
import {call, put, takeLatest} from "redux-saga/effects";
import SentryManager from "../../../../monitoring/Sentry";

function* getData (action) {
    try {
        const response = yield call(remote, {
            route: `/admin/dashboard/get-data/${action.data.startOfCalendarView}/${action.data.endOfCalendarView}`,
            method: 'get'
        });
        if (response.success) {
            yield put(getDataSuccess(response.data));
        } else {
            yield put(getDataFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getCalendarData (action) {
    try {
        const response = yield call(remote, {
            route: `/admin/dashboard/get-data/${action.data.startOfCalendarView}/${action.data.endOfCalendarView}`,
            method: 'get'
        });
        if (response.success) {
            yield put(getDataSmallCalendarSuccess(response.data));
        } else {
            yield put(getSmallCalendarDataFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getAllPatients (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/patients/get-patients',
            method: 'post',
            body: JSON.stringify({ ...action.data, skipArchived: true })
        });
        if (response.success) {
            yield put(getAllPatientsSuccess(response.data));
        } else {
            yield put(getAllPatientsFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* addBooking (action) {
    try {
        const response = yield call(remote, {
            route: '/bookings/add-booking',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(addBookingSuccess(response.data));
        } else {
            yield put(addBookingFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getCaseDetails (action) {
    const url = `/bookings/get-booking/${action.caseId}`;
    try {
        const response = yield call(remote, {
            route: url,
            method: 'get'
        });
        if (response.success) {
            yield put(getCaseSuccess(response.data));
        } else {
            yield put(getCaseFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* addDentist (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/dentists/add-dentist',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(addDentistSuccessAction(response.data));
        } else {
            yield put(addDentistFailureAction(response));
        }
    } catch (e) {
        console.log(e);
        SentryManager.captureException(e);
    }
}

function* addPatient (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/patients/add-patient',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(addPatientSuccess(response.data));
        } else {
            yield put(addPatientFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getParentCases () {
    try {
        const response = yield call(remote, {
            route: '/admin/cases/get-cases',
            method: 'get'
        });
        if (response.success) {
            yield put(getParentCasesSuccess(response.data));
        } else {
            yield put(getParentCasesFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* setFilterValues (action) {
    try {
        const response = yield call(remote, {
            route: '/cases/cases-table-columns',
            method: 'put',
            body: JSON.stringify(action.data.data)
        });
        if (response.success) {
            action.data.isAdmin
                ? yield put(setFilterValuesSuccess(response.data))
                : yield put(setFilterValuesSuccessDentist(response.data))
        } else {
            yield put(setFilterValuesFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* addVacationDays (action) {
    try {
        const response = yield call(remote, {
            route: `/reserved-days`,
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(addVacationDaysSuccess(response.data));
        } else {
            yield put(addVacationDaysFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getVacationDays (action) {
    try {
        const response = yield call(remote, {
            route: `/reserved-days/${action.data ? action.data : ''}`,
            method: 'get'
        });
        if (response.success) {
            yield put(getVacationDaysSuccess(response.data));
        } else {
            yield put(getVacationDaysFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* deleteVacationDay(data) {
    try {
        const response = yield call(remote, {
            route: `/reserved-days/${data.data}`,
            method: 'delete'
        });
        if (response.success) {
            yield put(deleteVacationDaySuccess(response.data));
            yield put(getVacationDaysSuccess(response.data));
        } else {
            yield put(deleteVacationDayFailure());
        }
    } catch (e) {
        console.error(e);
    }
}

export default function* watchAdminDashboard() {
    yield takeLatest(ADD_BOOKING_REQUEST , addBooking);
    yield takeLatest(GET_DASHBOARD_DATA_REQUEST , getData);
    yield takeLatest(GET_SMALL_CALENDAR_DATA_REQUEST , getCalendarData);
    yield takeLatest(GET_CASE_DETAILS_REQUEST , getCaseDetails);
    yield takeLatest(ADD_DENTIST_REQUEST, addDentist);
    yield takeLatest(ADD_PATIENT_DASHBOARD_REQUEST , addPatient);
    yield takeLatest(GET_PARENT_CASES_REQUEST , getParentCases);
    yield takeLatest(UPDATE_TABLE_CONFIG, setFilterValues);
    yield takeLatest(GET_ALL_PATIENTS_REQUEST, getAllPatients);
    yield takeLatest(ADD_VACATION_DAYS_REQUEST, addVacationDays);
    yield takeLatest(GET_VACATION_DAYS_REQUEST, getVacationDays);
    yield takeLatest(DELETE_VACATION_DAYS_REQUEST, deleteVacationDay);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/dashboard/saga.js